import { render, staticRenderFns } from "./claims.vue?vue&type=template&id=418528ac&scoped=true&"
import script from "./claims.vue?vue&type=script&lang=js&"
export * from "./claims.vue?vue&type=script&lang=js&"
import style0 from "./claims.vue?vue&type=style&index=0&id=418528ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418528ac",
  null
  
)

export default component.exports